export enum RiskAssessmentActionTypes {
  //all RiskAssessment
  GetRiskAssessment = 'RiskAssessment/all',
  GetRiskAssessmentSuccess = 'RiskAssessmentSuccess/all',
  GetRiskAssessmentFail = 'RiskAssessmentFail/all',
  //GetOneRiskAssessment
  GetOneRiskAssessment = 'RiskAssessment/one',
  GetOneRiskAssessmentSuccess = 'RiskAssessmentSuccess/one',
  GetOneRiskAssessmentFail = 'RiskAssessmentFail/one',
  //create RiskAssessment
  CreateRiskAssessment = 'RiskAssessment/create',
  CreateRiskAssessmentSuccess = 'RiskAssessmentSuccess/create',
  CreateRiskAssessmentFail = 'RiskAssessmentFail/create',
  //delete
  DeleteRiskAssessment = 'RiskAssessment/delete',
  DeleteRiskAssessmentSuccess = 'RiskAssessmentSuccess/delete',
  DeleteRiskAssessmentFail = 'RiskAssessmentFail/delete',
}
